module.exports = __webpack_public_path__ + "static/media/take-video-icon.7b02c8bc.svg";